<script setup>
import { ref, onMounted, computed } from 'vue';
import { useModals } from '@/utils/useModals';
import { useSettingsStore } from '@/stores/storeSettings';
import { useRequestsStore } from '@/stores/storeRequests';
import { useRouter } from 'vue-router';
import { sendMetrik } from '@/utils/metrika';

const { openModal } = useModals();
const storeSettings = useSettingsStore();
const storeRequests = useRequestsStore();
const router = useRouter();

const isShowLink = computed(() => storeSettings.statusSurveyChoose  ||  storeSettings.statusSurveyFinal );
const finalists = computed(() => storeSettings.statusSurveyChoose);
const addApplication = () => {
    if(storeSettings.statusSurveyRegistration && !storeRequests.isAuthenticated) {
        openModal('registration');        
        sendMetrik('reachGoal', 'Go')
    } 
    
    if(storeSettings.statusSurveyExtra && storeRequests.isAuthenticated) {
        router.push({ name: 'profile' });
    } 
    
    
    
}

onMounted(() => {
});

const statusUserApplicationDenied = computed(() => storeRequests.userData.survey?.status === 'denied');
</script>
<template>
    <a href="https://chefschoice.club/" target="_blank" rel="noopener noreferrer" class="btn">
        <span>chefschoice.club</span>
    </a>
    
        <!-- <button v-if="!isShowLink && !statusUserApplicationDenied" @click="addApplication" :class="['btn']" v-bind="$attrs"><slot></slot></button>  
        <a v-else-if="!statusUserApplicationDenied" :href="finalists ? '#finalists' : '#winners'" :class="['btn']" v-bind="$attrs"><slot></slot></a>   -->
    
</template>
<style lang='scss' scoped>
</style>